import { render, staticRenderFns } from "./list-detail.vue?vue&type=template&id=c75a6752&"
import script from "./list-detail.vue?vue&type=script&lang=ts&"
export * from "./list-detail.vue?vue&type=script&lang=ts&"
import style0 from "./list-detail.vue?vue&type=style&index=0&id=c75a6752&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports